import React from 'react';
import { Stack } from '@mui/material';
import { useFilePlayerContext } from '../FilePlayerContext';
import { FileListLayout } from './FileListLayout';
import { FileGridLayout } from './FileGridLayout';
import { FileListStateShape } from '../hooks/useFileListState';
import {
  LoadingState,
  ErrorState,
  EmptyState,
  LoadMoreButton,
} from './FilePanelHelpers';

export const FilesPanel = ({ fileListState }) => {
  const {
    filesQuery,
    setPage,
    hasMoreFiles,
  } = useFilePlayerContext();
  const { visibleFiles, listView } = fileListState;
  const { error: filesError, isLoading: filesLoading, isError: filesHasError } = filesQuery;

  const hasFetchedAnyFiles = filesQuery.data?.items?.length > 0;

  if (filesLoading) return <LoadingState />;
  if (filesHasError) return <ErrorState error={filesError} />;

  if (!visibleFiles.length && !hasMoreFiles && !hasFetchedAnyFiles) {
    return (
      <EmptyState message="No files available. Mail attachments you have opened or purchased will show here. Right now, there's nothing to see!" />
    );
  }

  return (
    <Stack spacing={2} mt={2}>
      {listView ? (
        <FileListLayout fileListState={fileListState} />
      ) : (
        <FileGridLayout fileListState={fileListState} />
      )}
      {hasMoreFiles && <LoadMoreButton setPage={setPage} isLoading={filesLoading} />}
    </Stack>
  );
};

FilesPanel.propTypes = {
  fileListState: FileListStateShape.isRequired,
};
